var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoProjects(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 32,
    viewBox: "0 0 54 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2374 9.3096H21.0499M35.7193 21.7803L46.1816 26.9237C47.2661 27.5826 48.4042 27.1943 48.375 25.8201L48.3016 7.64269C48.209 6.15078 47.3268 5.74369 46.0279 6.43316L35.6898 11.1223M11.8125 31.0172H30.6124C33.4083 31.0172 35.6749 28.783 35.6749 26.0269L35.7193 19.6264L35.6749 6.81447C35.6749 4.05843 33.4083 1.82422 30.6124 1.82422H11.8125C9.01656 1.82422 6.75 4.05843 6.75 6.81447V26.0269C6.75 28.783 9.01656 31.0172 11.8125 31.0172Z",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProjects);
export default __webpack_public_path__ + "static/media/no-projects.164fcff2ad0c6758d609fbe52c07d310.svg";
export { ForwardRef as ReactComponent };